import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function usePlan(data = {}) {
  const { enabled = true, queryParams = '', configs = {} } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getPlan() {
    return privateFetch.get(`/v1/admin/plan${queryParams}`, configs).then((res) => res.data);
  }

  return useQuery(['plan', { data }], getPlan, { enabled, keepPreviousData: true });
}

export default usePlan;
